import { theme } from 'antd';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFloors } from 'reduxStore/floors/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { LeafletMap, Loader } from 'zComponents/atoms';
import { AddFloorModal } from 'zComponents/molecules';
import { Collapse, Divider, Empty, Flex, Typography } from 'zui/Antd';
import ViewFloorHeader from './ViewFloorHeader';
import ViewSiteHeader from './ViewSiteHeader';

const { Title } = Typography;

function SiteFloorAccordion() {
	// 🎨 Hooks
	const {
		token: { colorBorder, paddingLG, paddingSM, colorBgBase, marginLG, borderRadius, margin, colorBorderSecondary }
	} = theme.useToken();

	// 📦 Redux state
	const filteredSites = useSelector(selectSites);
	const floors = useSelector(selectFloors);

	// 🌀 Loading state
	const [openAddFloorModal, setOpenAddFloorModal] = useState(null);

	const { loading: loadingFloors } = useSelector((state) => state.Floors);

	const items = filteredSites.map((site) => {
		const siteFloors = floors.filter((floor) => floor.siteID === site.siteID);

		const floorItems = siteFloors.map((floor) => ({
			key: floor.floorID,
			label: <ViewFloorHeader floorID={floor.floorID} />,
			children: (
				<Flex vertical gap={paddingSM}>
					{loadingFloors ? (
						<Loader />
					) : (
						<Flex
							style={{
								height: 317,
								borderStyle: 'dashed',
								borderRadius: borderRadius,
								borderColor: colorBorder,
								borderWidth: 2
							}}
							justify='center'
							align='center'
						>
							{floor?.mapID ? (
								<LeafletMap scrollWheelZoom url={floor.url} />
							) : (
								<Empty description='No floor map available for this floor' />
							)}
						</Flex>
					)}
				</Flex>
			),
			style: {
				marginBottom: margin,
				border: `1px solid ${colorBorder}`,
				borderRadius: borderRadius
			}
		}));

		return {
			key: site.siteID,
			label: <ViewSiteHeader siteID={site.siteID} />,
			children: (
				<>
					<Divider style={{ margin: 0, color: colorBorderSecondary }} />

					<Flex vertical gap={paddingSM} style={{ marginTop: paddingLG, marginBottom: marginLG }}>
						<Title level={5} style={{ margin: 0 }}>
							Site Layout
						</Title>
						<Flex
							style={{
								height: 317,
								borderStyle: 'dashed',
								borderRadius: borderRadius,
								borderColor: colorBorder,
								borderWidth: 2,
								overflow: 'hidden'
							}}
							justify='center'
							align='center'
						>
							{site?.mapID ? (
								<LeafletMap scrollWheelZoom url={site.url} />
							) : (
								<Empty description={`${site.name} has not site layout.`} />
							)}
						</Flex>
					</Flex>

					<Flex vertical>
						<Flex justify='space-between' align='center' style={{ marginBottom: paddingSM }}>
							<Title level={5} style={{ margin: 0 }}>
								Floors
							</Title>
							<AddFloorModal
								siteID={site.siteID}
								setOpen={(isOpen) =>
									isOpen ? setOpenAddFloorModal(site.siteID) : setOpenAddFloorModal(null)
								}
								open={openAddFloorModal === site.siteID}
							/>
						</Flex>

						{siteFloors.length > 0 ? (
							<Collapse
								items={floorItems}
								style={{
									backgroundColor: colorBgBase
								}}
								bordered={false}
							/>
						) : (
							<Empty description={`${site.name} has no floors.`} style={{ marginBottom: margin }} />
						)}
					</Flex>
				</>
			),
			style: {
				marginBottom: margin,
				border: `1px solid ${colorBorder}`,
				borderRadius: borderRadius
			}
		};
	});

	return (
		<Collapse
			items={items}
			style={{
				backgroundColor: colorBgBase,
				width: '100%'
			}}
			bordered={false}
		/>
	);
}

export default SiteFloorAccordion;
